const IMAGES = [
  { src: "/assets/food-1.jpg", alt: "Mini burgery se sýrovou omáčkou", span: "md:col-span-2 md:row-span-2" },
  { src: "/assets/food-2.jpg", alt: "Zapečené jídlo s chlebem", span: "" },
  { src: "/assets/food-3.jpg", alt: "Pečené koleno s přílohou", span: "md:row-span-2" },
  { src: "/assets/food-4.jpg", alt: "Kuřecí křidélka se sezamem", span: "" },
  { src: "/assets/food-5.jpg", alt: "Boršč se smetanou", span: "md:col-span-2" },
];

export default function GallerySection() {
  return (
    <section id="gallery" data-testid="gallery-section" className="py-20 md:py-32 bg-[#051F16]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 reveal reveal-up">
          <p className="text-xs uppercase tracking-[0.3em] text-[#EAB308] mb-4">
            Nahlédněte
          </p>
          <h2 className="font-['Playfair_Display'] text-3xl md:text-5xl font-semibold text-[#F0FDF4] tracking-tight">
            Galerie
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-3 auto-rows-[200px] md:auto-rows-[220px] reveal reveal-scale stagger-children">
          {IMAGES.map((img, i) => (
            <div
              key={i}
              className={`gallery-item rounded-sm overflow-hidden ${img.span}`}
              data-testid={`gallery-image-${i}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
